import { createSlice } from '@reduxjs/toolkit';

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState: {
        feedbackList: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        feedbackResponse: { data: null, loading: false, error: null }, // For responding to feedback
        feedbackSubmission: { data: null, loading: false, error: null }, // For submitting feedback
    },
    reducers: {
        // Start actions
        submitFeedbackStart: (state) => {
            state.feedbackSubmission.loading = true;
            state.feedbackSubmission.error = null;
        },
        fetchFeedbackStart: (state) => {
            state.feedbackList.loading = true;
            state.feedbackList.error = null;
        },
        respondFeedbackStart: (state) => {
            state.feedbackResponse.loading = true;
            state.feedbackResponse.error = null;
        },

        // Success actions
        submitFeedbackSuccess: (state, action) => {
            state.feedbackSubmission.loading = false;
            state.feedbackSubmission.data = action.payload;
        },
        fetchFeedbackSuccess: (state, action) => {
            state.feedbackList = { ...action.payload, loading: false };
        },
        respondFeedbackSuccess: (state, action) => {
            state.feedbackResponse.loading = false;
            state.feedbackResponse.data = action.payload;
        },

        // Fail actions
        submitFeedbackFail: (state, action) => {
            state.feedbackSubmission.loading = false;
            state.feedbackSubmission.error = action.payload;
        },
        fetchFeedbackFail: (state, action) => {
            state.feedbackList.loading = false;
            state.feedbackList.error = action.payload;
        },
        respondFeedbackFail: (state, action) => {
            state.feedbackResponse.loading = false;
            state.feedbackResponse.error = action.payload;
        },
    },
});

export const {
    submitFeedbackStart,
    submitFeedbackSuccess,
    submitFeedbackFail,
    fetchFeedbackStart,
    fetchFeedbackSuccess,
    fetchFeedbackFail,
    respondFeedbackStart,
    respondFeedbackSuccess,
    respondFeedbackFail,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;